import React from 'react';
import { Link } from 'react-router-dom';

export const IndexController = (props) => {
    const { list } = props.profile;
    console.log(`developers__list`, list);
    return (
        <div className={`console console_developer--type`}>
           <h1>Выберите аккаунт разработчика</h1>
            <div className="developers__list">
                <div className={`list__wrp`}>
                    {list.map(i => {
                        return (
                            <DeveloperRow
                                key={i.id}
                                {...i}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

const DeveloperRow = ({ id, logo, title, type }) => {
    return (
        <Link className={`developer`} to={`/console/${id}`}>
            <span className={`developer__logo`} style={logo ? {backgroundImage: `url(${logo})`} : {}}/>
            <span className={`developer__info`}>
                <span className={`developer__info--title`}>{title}</span>
                <span className={`developer__info--type`}>{type}</span>
            </span>
        </Link>
    );
}

export default IndexController;